import type { OpportunityCycle, TimeframeKey } from '../types'
import type { OpportunityItem } from '@/modules/oportunidades/types'

export function cycleWindow(cycle: OpportunityCycle, now = new Date()): { start: Date; end: Date } {
  const z = new Date(now.toISOString()) // ensure UTC-like
  const y = z.getUTCFullYear()
  const m = z.getUTCMonth()
  const d = z.getUTCDate()

  if (cycle === 'day') {
    const start = new Date(Date.UTC(y, m, d, 0, 0, 0, 0))
    const end = new Date(Date.UTC(y, m, d + 1, 0, 0, 0, 0))
    return { start, end }
  }
  if (cycle === 'week') {
    const weekday = new Date(Date.UTC(y, m, d)).getUTCDay() // 0..6 (Sun..Sat)
    const offsetToMonday = (weekday + 6) % 7 // 0 for Mon, 6 for Sun
    const monday = new Date(Date.UTC(y, m, d - offsetToMonday, 0, 0, 0, 0))
    const next = new Date(Date.UTC(monday.getUTCFullYear(), monday.getUTCMonth(), monday.getUTCDate() + 7, 0, 0, 0, 0))
    return { start: monday, end: next }
  }
  // month
  const start = new Date(Date.UTC(y, m, 1, 0, 0, 0, 0))
  const end = new Date(Date.UTC(y, m + 1, 1, 0, 0, 0, 0))
  return { start, end }
}

export function toRawTfFromShort(tf?: string | null): TimeframeKey | null {
  const t = String(tf || '').toUpperCase()
  if (!t) return null
  if (t === '5MIN') return '5'
  if (t === '15MIN') return '15'
  if (t === '30MIN') return '30'
  if (t === '1H') return '60'
  if (t === '4H') return '240'
  if (t === '12H') return '720'
  if (t === '1D' || t === 'D') return 'D'
  if (t === '1W' || t === 'W') return 'W'
  if (t === '1M' || t === 'M') return 'M'
  return null
}

export function timeframeForItem(it: OpportunityItem): TimeframeKey | null {
  const upper = toRawTfFromShort(it.fractalUpper || null)
  if (upper) return upper
  const lower = toRawTfFromShort(it.fractalLower || null)
  if (lower) return lower
  return null
}

